export default __webpack_public_path__ + "static/media/invitation-left.4c386545.png";